module.exports = __webpack_public_path__ + "img/Takeaway Pay Icon - charcoal.206ffd52.svg";